import defaultLogo from "../assets/img/LOGO COACHING MASTER - CLAUDIO MESSINA LOGO VETTORIALE_Tavola disegno 1.png";

const logoAltText = window.__env.LOGO_ALT_TEXT || "Coaching Master Logo";

type Props = {
  height?: string | number;
  width?: string | number;
  className?: string;
  logo?: string;
};

export default function Logo({ height, width, className, logo }: Props) {
  
  return (
    <img
      alt={logoAltText}
      src={logo || defaultLogo}
      height={height}
      width={width}
      className={className}
    />
  );
}
